import { WIDGET_URL } from "../../../config";

const HtmlCode = ({ botScriptURL }) => (
  <pre>
    <span className="c-cm">
      &lt;!-- Paste before the closing &lt;/body&gt; tag --&gt;
    </span>
    {"\n\n"}
    {"<"}
    <span className="c-tag">script</span>
    {"\n"}
    {"  "}
    <span className="c-attr">src</span>
    {"="}
    <span className="c-val">{`"${botScriptURL}"`}</span>
    {"\n"}
    {"  "}
    <span className="c-attr">async</span>
    {">"}
    {"\n"}
    {"</"}
    <span className="c-tag">script</span>
    {">"}
    {"\n"}
  </pre>
);

export default HtmlCode;
